import { useContext } from "react";
import { TableRowContext } from "./TableRowContext";

/**
 * Indicates whether the current row is a child row or not.
 * @returns True if the row is a child row, otherwise false.
 */
export function useIsChildRow(): boolean {
  const { isSubRow } = useContext(TableRowContext);
  return isSubRow;
}
